import { QueryFunctionContext } from '@tanstack/react-query';

import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const QUERY_KEY = 'relevance_test_runs';

export const queryRelevanceTestRuns = (
    context: QueryFunctionContext<App.RelevanceTestRuns.QueryKey, number>,
): Promise<Models.PageResult<Models.IngestConfigApi.RelevanceTests.RelevanceTestRun>> => {
    const { queryKey } = context;
    const [, accessToken, search] = queryKey;
    const { testDefinitionId, offset, limit } = search;

    return RelevanceTestsService.getTestRunsForDefinition(
        accessToken,
        testDefinitionId,
        offset,
        limit,
    );
};
